export default __webpack_public_path__ + "assets/images/5.58388e.avif";